import * as React from "react";
import { memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIdCard = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M16 10h2M16 14h2M6.17 15a3 3 0 0 1 5.66 0" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 9,
			cy: 11,
			r: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 14,
			x: 2,
			y: 5,
			rx: 2
		})
	]
});
const Memo = memo(SvgIdCard);
export default Memo;
